<template>
  <div class="banner-home">
    <div class="relative bg-yellow">
      <div class="pdv-container">
        <div class="banner-home-content">
          <h1 class="banner-home-title2">Admisión <u>2025</u></h1>
          <h2 class="banner-home-title">
            Bienvenido a tu mejor preparación <u>PAES</u>
          </h2>
          <h5 class="banner-home-text descuento">
             Matricúlate en pocos minutos y en donde quiera que estés
          </h5>
          <div
            @click="goToRecomendedCourses"
            class="banner-home-green-content only-mobile"
          >
            <p class="first-text">Encuentra tu programa perfecto con hasta un</p>
            <!--h2>{{ discount }}% <span>Descuento</span></h2-->
            <h2>45% <span>Descuento</span></h2>
            <!--p class="second-text"> + descuento por clases contratadas</p-->
            <img
              src="/images/featured/green-arrow.svg"
              alt="arrow"
              class="gree-arrow"
            />
          </div>
          <div
            @click="goToRecomendedCourses"
            class="banner-home-green-content only-desktop"
          >
            <p class="first-text">
              Encuentra tu programa perfecto con hasta un
            </p>
            <h2>45% de Descuento</h2>
            <!-- <h2>{{ discount }}% de Descuento</h2> -->
            <!-- <p class="second-text"> + descuento por clases contratadas</p>  -->
            <img
              src="/images/featured/green-arrow.svg"
              alt="arrow"
              class="gree-arrow"
            />
          </div>
          <div class="banner-home-button-content only-mobile">
            <Button
              :title="'Cotiza y matricúlate Online'"
              :size="'medium'"
              :type="'primary'"
              :fullWidth="true"
              @onClick="goToRecomendedCourses"
            ></Button>
          </div>
          <div class="banner-home-text">
            <h5 class="banner-home-text descuento">
              Mientras más clases selecciones,  mayor es tu descuento 
             
              
          </h5>

          </div>
          <div class="banner-home-button-content only-desktop">
            <Button
              :title="'Cotiza y matricúlate Online'"
              :size="'large'"
              :type="'primary'"
              @onClick="goToRecomendedCourses"
            ></Button>
          </div>
        </div>
      </div>
      <div class="absolute banner-texture-mobile only-mobile"></div>
      <div class="absolute banner-texture-desktop only-desktop"></div>
    </div>
    <img
      src="/images/featured/esquina-derecha-mobile.svg"
      style="width: 100%"
      alt="triangle"
      class="only-mobile"
    />
    <img
      src="/images/featured/esquina-derecha-desktop.svg"
      style="width: 100%"
      alt="triangle"
      class="only-desktop"
    />
  </div>
</template>
<script>
import Button from "@/components/featured/Button";

export default {
  components: {
    Button,
  },
  data() {
    return {
      enabledPrograms: [],
      highSchoolAcademy: null,
      bachelorsAcademy: null,
      pdvX: null,
      discount: null,
    };
  },
  methods: {
    goToRecomendedCourses() {
      this.$router.push({ name: "Re-Step1" });
    },
    loadEnabledPrograms() {
      this.Axios.get("/programs/enabled").then((response) => {
        this.enabledPrograms = response.data;
        this.highSchoolAcademy = response.data[0];
        this.bachelorsAcademy = response.data[1];
        this.pdvX = response.data[2];
      });
    },
    configureSelectedProgram(program, isPdvX) {
      this.$store.dispatch("addSelectedProgramInfo", { ...program, isPdvX });
    },
    goToStudentForm(program, formPageName, isPdvX) {
      // this.$router.push({ name: 'Step1' });
      this.$store.dispatch("cleanLocalStorage");
      this.configureSelectedProgram(program, isPdvX);
      this.$router.push({ name: formPageName });
    },
  },
  mounted() {
    this.Axios.get("/dashadmin/infogeneral").then((response) => {
      this.discount = response.data[0].discount;
    });
    setInterval(this.discountSeconds, 1000);
  },
};
</script>

<style lang="scss" scoped>
.banner-home {
  background: $neutralwhite;

  .bg-yellow {
    background: $amarrillo50;
  }
}
.banner-home-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 10;
  @media (max-width: 768px) {
    margin: 0 24px;
  }

  @media (min-width: 769px) {
    margin: 0 180px;
  }

  .banner-home-title2 {
    margin-bottom: 0;
    color: $colorTerciario;
    font-family: "Poppins-ExtraBold", sans-serif;
    z-index: 10;

    @media (max-width: 768px) {
      margin-top: 24px;
      margin-bottom: 8px;
      font-size: 31px;
      line-height: 30px;
      text-align: left;
    }
    @media (min-width: 769px) {
      margin-top: 40px;
      font-size: 40px;
      line-height: 40px;
      text-align: center;
    }
  }

  .banner-home-title {
   
    color: $colorTerciario;
    font-family: "Poppins-ExtraBold", sans-serif;
    z-index: 10;

    @media (max-width: 768px) {
      margin-bottom: 2px;
      font-size: 20px;
      line-height: 28px;
      text-align: center;
    }
    @media (min-width: 769px) {
      margin-top: 16px;
      font-size: 48px;
      line-height: 58px;
      text-align: center;
    }
  }

  .banner-home-text {
    text-align: center;
    color: $neutral80;
    font-family: "Poppins-Regular", sans-serif;
    z-index: 10;
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 28px;
      
    }
    @media (min-width: 769px) {
      font-size: 27px;
      line-height: 37px;
      margin: 16px 0 24px 0;
    }
  }

  .banner-home-green-content {
    background-color: $verdeOscuro;
    padding: 24px 20px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    z-index: 10;
    position: relative;
    &:hover {
      cursor: pointer;
    }

    @media (max-width: 768px) {
      width: 100%;
    }
    @media (min-width: 769px) {
      width: auto;
      text-align: center;
    }

    .gree-arrow {
      position: absolute;
      width: 30px;
      height: 37px;
      left: -17px;
      bottom: -22px;
    }

    .first-text {
      color: #fff;
      margin-bottom: 10px;
      font-size: 22px;
      line-height: 28px;
      font-family: "Poppins-Medium", sans-serif;
    }

    .second-text {
      color: #fff;
      margin-bottom: 10px;
      font-size: 29px;
      line-height: 28px;
      padding-top: 8px;
      font-family: "Poppins-Medium", sans-serif;
    }

    h2 {
      color: #fff;
      font-size: 40px;
      line-height: 50px;
      font-family: "Poppins-Bold", sans-serif;
      margin-bottom: 0;

      span {
        @media (max-width: 768px) {
          font-family: "Poppins-Bold", sans-serif;
          margin-bottom: 0;
          font-size: 36px !important;
          line-height: 40px !important;
        }
      }
    }
  }

  .banner-home-button-content {
    z-index: 10;
    @media (max-width: 768px) {
      margin-top: 28px;
      margin-bottom: 18px;
      width: 100%;
    }
    @media (min-width: 769px) {
      margin-top: 10px;
      margin-bottom: 48px;
    }
  }
}

.banner-texture-mobile {
  background-image: url("/images/featured/texture-home-mobile.svg");
  background-size: cover;
  background-repeat: no-repeat;
  top: -20px;
  right: 0;
  left: 0;
  bottom: 0;
}
.banner-texture-desktop {
  background-image: url("/images/featured/texture-home-desktop.svg");
  background-size: cover;
  background-repeat: no-repeat;
  top: -20px;
  right: 0;
  left: 0;
  bottom: 0;
}

.descuento {
  font-family: "Poppins-ExtraBold", sans-serif;
  font-size: 30px;
  font-weight: bold;
  color: black;
  padding-top: 20px;
}
</style>